import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class PostsService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  getPageItems() {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/pages/items?lang=${lang}`);
  }


  getPageByItems(params: any) {
    const lang = this.languageService.getLanguage();

    // params-ში პირდაპირ ჩავამატოთ search (q)
    return this.http.get(`${environment.apiUrl}admin/pages/items/by/type`, {
      params: { 
        ...params, 
        lang, 
        q: params.q ?? ''   // 🆕 თუ q არსებობს, ჩავსვამთ
      }
    });
  }


  delete(id: number = 0, source: string = ''){
    return this.http.post(`${environment.apiUrl}admin/delete/post`, { id: id, source: source });
  }


}
